import { getCurrentDevice } from './utils';
import AOS from 'aos';
import fullsizeImagesUI from './fullsize';
import slidersUI from './sliders';
import currentYear from './current-year';
import shaveUI from './shave-ui';

; (function (window, document, $) {
	$('a[href^="tel"]').each(function () {
		const linkHref = $(this).attr('href');

		$(this).attr('href', linkHref.replace(/ /igm, ''));
	});

	$(".banner").each(function () {
		if (getCurrentDevice() === 'desktop') {
			const $banner = $(this);
			const $holder = $banner.find(".fullsize-image");
			const defaultBg = $holder.css("background-image");

			console.log(defaultBg, $holder, $banner)

			$banner.find(".banner__urls a").on("mouseenter", function () {
				const newSrc = $(this).data("image");
				if (newSrc) {
					$holder.css("background-image", `url(${newSrc})`);
				}
			});

			$banner.find(".banner__urls a").on("mouseleave", function () {
				$holder.css("background-image", defaultBg);
			});
		} else {
			return;
		}
	});

	const radioName = 'mattress_filling'; // 💡 specify the name here

	$(`input[name="${radioName}"]`).each(function () {
		$(this).on('change', function () {
			const selectedVal = $(this).val();

			// hide all paragraphs
			$('.radio-section__entry p').hide();

			// show only the matching one
			$('#' + selectedVal).show();
		});
	});

	$('.js-slider-images').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: '.js-slider-thumbs'
	});
	$('.js-slider-thumbs').slick({
		slidesToShow: 6,
		slidesToScroll: 1,
		asNavFor: '.js-slider-images',
		dots: true,
		focusOnSelect: true,
		vertical: true
	});


	const $dropdownDesktop = $('.dropdown');
	const $dropdownLink = $('.nav .has-dropdown > a');
	const $navBtnParentDesktop = $('.nav > li');

	$dropdownLink.on('click', function (event) {
		var $link = $(this);

		if (!$link.hasClass('clicked')) {
			event.preventDefault();

			$link.addClass('clicked');

			$link
				.siblings('.dropdown')
				.slideToggle()
				.parent()
				.siblings()
				.find('.dropdown')
				.slideUp()
				.siblings()
				.removeClass('clicked')
		}
	});

	$(window).on('load resize', function () {
		if ($(window).width() > 1024) {
			$navBtnParentDesktop.addClass('hover');
			$('.nav').removeAttr('style');
			$dropdownDesktop.removeAttr('style');
			$dropdownLink.removeClass('clicked');
		} else {
			$navBtnParentDesktop.removeClass('hover');
		}
	});

	$('.js-nav-btn').on('click', function (event) {
		event.preventDefault();

		$('.header .header__aside').slideToggle();
	});

	fullsizeImagesUI();

	slidersUI();

	// Add js-year-container class where you want to print the current year
	currentYear();

	shaveUI();

	AOS.init({
		duration: 500,
		easing: 'ease-in-cubic',
		once: true,
		disable: 'mobile'
	});
})(window, document, window.jQuery);
